<script setup lang="ts">
import { onMounted } from 'vue';

import { ResizeSide, useResizableWithStorage } from './resizable';

const { storageKey, resizeSide = ResizeSide.RIGHT } = defineProps<{
  storageKey: string;
  resizeSide?: ResizeSide;
}>();

const { width, loadWithFromStorage, onStartResize } = useResizableWithStorage(
  () => storageKey,
  () => resizeSide,
);

onMounted(() => {
  loadWithFromStorage();
});
</script>

<template>
  <div
    class="relative flex h-full"
    :style="{ width: `${width}px` }"
  >
    <slot />

    <div
      class="absolute top-0 z-20 h-full w-[10px] cursor-col-resize transition-colors duration-200 hover:bg-[color:color-mix(in_srgb,var(--button-primary-color),transparent_80%)]"
      :class="resizeSide === ResizeSide.LEFT ? 'left-0' : 'right-0'"
      @mousedown="onStartResize"
    />
  </div>
</template>
